import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LocationService {
  private _coords = signal<GeolocationCoordinates | null>(null);
  private _denied = signal(false);
  private _loading = signal(false);

  async requestLocation(): Promise<void> {
    this._loading.set(true);

    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        this._denied.set(true);
        this._loading.set(false);
        reject('Geolocation not supported');
        return;
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          
          this._coords.set(position.coords);
          this._loading.set(false);
          resolve();
        },
        (error) => {
          this._denied.set(true);
          this._loading.set(false);
          reject(error);
        }
      );
    });
  }

  /** readonly signals for consumers */
  readonly coords = this._coords.asReadonly();
  readonly denied = this._denied.asReadonly();
  readonly loading = this._loading.asReadonly();
}
